/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiFeedbacksIdQueryResponse, GetApiFeedbacksIdPathParams, GetApiFeedbacksIdQueryParams, GetApiFeedbacksId400, GetApiFeedbacksId401, GetApiFeedbacksId403, GetApiFeedbacksId404, GetApiFeedbacksId500 } from "../../types/GetApiFeedbacksId.ts";
import { getApiFeedbacksIdQueryResponseSchema } from "../../zod/FeedbackSchemas/getApiFeedbacksIdSchema.ts";

function getGetApiFeedbacksIdUrl({ id }: { id: GetApiFeedbacksIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/feedbacks/${id}` as const }  
  return res
}

/**
 * @summary Получить чат
 * {@link /api/feedbacks/:Id}
 */
export async function getApiFeedbacksId({ id, params }: { id: GetApiFeedbacksIdPathParams["Id"]; params?: GetApiFeedbacksIdQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiFeedbacksIdQueryResponse, ResponseErrorConfig<GetApiFeedbacksId400 | GetApiFeedbacksId401 | GetApiFeedbacksId403 | GetApiFeedbacksId404 | GetApiFeedbacksId500>, unknown>({ method : "GET", url : getGetApiFeedbacksIdUrl({ id }).url.toString(), params, ... requestConfig })  
  return getApiFeedbacksIdQueryResponseSchema.parse(res.data)
}